var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"position-absolute end-0 top-0 mt-1 me-1",staticStyle:{"z-index":"100"},attrs:{"variant":"danger"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" X ")])}
var staticRenderFns = []

export { render, staticRenderFns }